import { useTranslation } from "react-i18next";
import { getImageURL } from "../services/ImageService.js";
import { Footer } from "../components/Footer/Footer.js";
import { Hero } from "../components/Hero/Hero.js";
import { CustomerSection } from "../components/CustomerSection/CustomerSection.js";
import { PageMeta } from "../components/PageMeta/PageMeta.js";
import { TimberSection } from "./Home/TimberSection.js";
import { ForestManagementSection } from "./Home/ForestManagementSection.js";
import { DamageInventorySection } from "./Home/DamageInventorySection.js";
import { CustomerQuote } from "../components/CustomerQuote/CustomerQuote.js";
import { getImage } from "../services/ImageService.js";
import { ForestOwnerSection } from "./Home/ForestOwnerSection.js";
import { WildlifeSection } from "./Home/WildlifeSection.js";

export function Home() {
    const { t } = useTranslation();
    const confettiBackgroundImagePath = getImageURL("confetti.png");

    return (
        <div
            className="flex flex-col items-center bg-white bg-center bg-no-repeat bg-cover"
            style={{ backgroundImage: confettiBackgroundImagePath }}
        >
            <PageMeta
                description={t("gf-hero-subtitle")}
                path="/"
            />
            <Hero />
            <CustomerSection />
            <div className="flex flex-col w-full gap-24 lg:gap-48">
                <TimberSection />
                <ForestManagementSection />
                <DamageInventorySection />
                <div className="w-full aspect-video bg-[#2D3532]">
                    <iframe
                        width="100%"
                        height="100%"
                        src="https://player.vimeo.com/video/1083456758?badge=0&amp;autopause=0&amp;player-id=0&amp;app-id=58479"
                        style={{ border: "0" }}
                        allow="fullscreen"
                        title="Meet Global Forester"
                    ></iframe>
                    <script src="https://player.vimeo.com/api/player.js"></script>
                </div>
                <script src="https://player.vimeo.com/api/player.js"></script>
                <ForestOwnerSection />
                <div className="w-full px-12 lg:px-24 xl:px-60 max-w-[180rem] mx-auto">
                    <CustomerQuote
                        img={getImage("quotes/peter.png")}
                        className="bg-gray text-white !rounded-[6rem] lg:!rounded-[8rem] xl:!rounded-[10rem] lg:!px-24 xl:!px-40"
                        quote={t("home-damage-inventory-customer-2")}
                        customer="Peter Semb, Norra Skog"
                    />
                </div>
                <WildlifeSection />
            </div>
            <Footer />
        </div>
    );
}
